import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { productService } from '../services/firebaseService';
import { getCategoryIcon } from './CustomIcons';

// Smooth scroll to top function
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// --- SVG Icons ---
const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
);

const ChevronDownIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
  </svg>
);
// --- End SVG Icons ---

// --- Injected CSS Styles ---
const NavbarStyles = () => {
  React.useEffect(() => {
    const css = `
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      /* --- ADD THESE LINES --- */
      body, .App {
        overflow-x: hidden;
      }
      /* --- END OF ADDED LINES --- */
      @keyframes fadeInDown {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideInRight {
        from {
          transform: translateX(100%);
        }
        to {
          transform: translateX(0);
        }
      }

      .navbar {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 251, 255, 0.98) 100%);
        backdrop-filter: blur(20px) saturate(180%);
        -webkit-backdrop-filter: blur(20px) saturate(180%);
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.95rem;
        font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif;
        position: sticky;
        top: 0;
        z-index: 999;
        border-bottom: 1px solid rgba(0, 115, 177, 0.12);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 16px rgba(0, 115, 177, 0.08);
      }

      .navbar.scrolled {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.99) 0%, rgba(245, 250, 255, 0.99) 100%);
        box-shadow: 0 4px 24px rgba(0, 115, 177, 0.12);
        border-bottom: 1px solid rgba(0, 115, 177, 0.15);
        height: 80px;
      }

      .navbar-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        max-width: 1400px;
        width: 100%;
        padding: 0 50px;
      }

      .navbar-logo {
        color: #1d1d1f;
        justify-self: start;
        cursor: pointer;
        text-decoration: none;
        font-size: rem;
        display: flex;
        align-items: center;
        font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif;
        font-weight: 700;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
        position: relative;
        z-index: 1001;
      }

      .navbar-logo::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #0073b1, #6bbe44);
        border-radius: 2px;
        transition: width 0.3s cubic-bezier(0.4, 0, 0.6, 1);
      }

      .navbar-logo:hover::after {
        width: 100%;
      }

      .navbar-logo:hover {
        transform: translateY(-2px) scale(1.02);
      }

      .logo-img {
        height: 140px;
        margin-right: 12px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
        filter: drop-shadow(0 2px 8px rgba(0, 115, 177, 0.15));
      }

      .navbar-logo:hover .logo-img {
        transform: scale(1.08) rotate(-2deg);
        filter: drop-shadow(0 4px 12px rgba(0, 115, 177, 0.25));
      }

      .menu-icon {
        display: none;
        cursor: pointer;
        color: #0073b1;
        padding: 10px;
        border-radius: 12px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.1), rgba(107, 190, 68, 0.1));
        border: 2px solid rgba(0, 115, 177, 0.15);
        z-index: 1001;
        position: relative;
      }

      .menu-icon svg {
        width: 24px;
        height: 24px;
        display: block;
        pointer-events: none;
      }

      .menu-icon:hover {
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.18), rgba(107, 190, 68, 0.18));
        transform: scale(1.05);
        border-color: rgba(0, 115, 177, 0.25);
      }

      .menu-icon:active {
        transform: scale(0.98);
      }

      .nav-menu {
        display: flex;
        list-style: none;
        text-align: center;
        gap: 6px;
        align-items: center;
        margin: 0;
        padding: 0;
      }

      .nav-item {
        height: 75px;
        display: flex;
        align-items: center;
        position: relative;
      }

      .nav-links {
        color: #1d1d1f;
        display: flex;
        align-items: center;
        text-decoration: none;
        padding: 12px 24px;
        height: auto;
        border-radius: 14px;
        font-weight: 600;
        letter-spacing: -0.02em;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
        position: relative;
        overflow: hidden;
        border: 2px solid transparent;
      }

      .nav-links::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.5s ease;
      }

      .nav-links:hover::before {
        left: 100%;
      }

      .nav-links:hover {
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.12), rgba(107, 190, 68, 0.12));
        color: #0073b1;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 115, 177, 0.15);
        border-color: rgba(0, 115, 177, 0.2);
      }

      .nav-links.active {
        background: linear-gradient(135deg, #0073b1, #005a8c);
        color: #fff;
        font-weight: 700;
        box-shadow: 0 6px 20px rgba(0, 115, 177, 0.3);
      }

      /* --- Dropdown Styles --- */
      .nav-links .chevron-icon {
        width: 14px;
        height: 14px;
        margin-left: 6px;
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.6, 1);
      }

      .nav-links .chevron-icon.open {
        transform: rotate(180deg);
      }

      .dropdown-menu {
        position: absolute;
        top: calc(100% + 12px);
        left: 50%;
        transform: translateX(-50%);
        background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
        list-style: none;
        padding: 12px;
        border-radius: 20px;
        box-shadow: 0 20px 60px rgba(0, 115, 177, 0.2), 0 0 0 1px rgba(0, 115, 177, 0.1);
        min-width: 280px;
        text-align: left;
        opacity: 0;
        visibility: hidden;
        transform: translateX(-50%) translateY(-15px) scale(0.95);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.6, 1);
        max-height: 450px;
        overflow-y: auto;
        border: 2px solid rgba(0, 115, 177, 0.1);
        margin: 0;
      }

      .dropdown-menu::before {
        content: '';
        position: absolute;
        top: -8px;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        width: 16px;
        height: 16px;
        background: linear-gradient(135deg, #ffffff, #f8fbff);
        border-left: 2px solid rgba(0, 115, 177, 0.1);
        border-top: 2px solid rgba(0, 115, 177, 0.1);
      }

      .dropdown-menu::-webkit-scrollbar {
        width: 8px;
      }

      .dropdown-menu::-webkit-scrollbar-track {
        background: rgba(0, 115, 177, 0.05);
        border-radius: 10px;
      }

      .dropdown-menu::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #0073b1, #6bbe44);
        border-radius: 10px;
      }

      .nav-item:hover .dropdown-menu,
      .dropdown-menu.active {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(0) scale(1);
      }

      .dropdown-menu li {
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
      }

      .dropdown-link {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 14px 18px;
        text-decoration: none;
        color: #1d1d1f;
        font-size: 0.95rem;
        border-radius: 14px;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
        position: relative;
        overflow: hidden;
        margin-bottom: 4px;
        border: 2px solid transparent;
      }

      .dropdown-link::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(180deg, #0073b1, #6bbe44);
        transform: scaleY(0);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.6, 1);
      }

      .dropdown-link:hover::before {
        transform: scaleY(1);
      }

      .dropdown-link:hover {
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.12), rgba(107, 190, 68, 0.12));
        color: #0073b1;
        transform: translateX(6px);
        box-shadow: 0 4px 12px rgba(0, 115, 177, 0.1);
        border-color: rgba(0, 115, 177, 0.15);
      }

      .dropdown-link.active {
        background: linear-gradient(135deg, rgba(0, 115, 177, 0.18), rgba(107, 190, 68, 0.18));
        color: #0073b1;
        font-weight: 700;
        box-shadow: 0 4px 16px rgba(0, 115, 177, 0.2);
        border-color: rgba(0, 115, 177, 0.2);
      }

      .dropdown-link.active::before {
        transform: scaleY(1);
      }

      .dropdown-link svg {
        flex-shrink: 0;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.6, 1);
      }

      .dropdown-link:hover svg {
        transform: scale(1.2) rotate(5deg);
      }

      /* --- Mobile Menu Styles --- */
      @media screen and (max-width: 960px) {
        .navbar {
          height: 70px;
        }

        .navbar.scrolled {
          height: 68px;
        }

        .navbar-container {
          padding: 0 20px;
        }

        .logo-img {
          height: 100px;
        }

        .menu-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .nav-menu {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: 100%;
          height: calc(100vh - 70px);
          position: fixed;
          top: 70px;
          left: 0;
          right: 0;
          transform: translateX(100%);
          transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          background: linear-gradient(180deg, #ffffff 0%, #f5faff 100%);
          gap: 0;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 20px 16px 40px;
          box-shadow: none;
          align-items: stretch;
        }

        .nav-menu::-webkit-scrollbar {
          width: 6px;
        }

        .nav-menu::-webkit-scrollbar-track {
          background: rgba(0, 115, 177, 0.05);
        }

        .nav-menu::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #0073b1, #6bbe44);
          border-radius: 3px;
        }

        .nav-menu.active {
          transform: translateX(0);
        }

        .nav-item {
          width: 100%;
          height: auto;
          opacity: 0;
          transform: translateX(20px);
          transition: opacity 0.3s ease, transform 0.3s ease;
          display: block;
        }

        .nav-item.has-dropdown {
          display: block;
        }

        .nav-menu.active .nav-item {
          opacity: 1;
          transform: translateX(0);
        }

        .nav-menu.active .nav-item:nth-child(1) { transition-delay: 0.05s; }
        .nav-menu.active .nav-item:nth-child(2) { transition-delay: 0.1s; }
        .nav-menu.active .nav-item:nth-child(3) { transition-delay: 0.15s; }
        .nav-menu.active .nav-item:nth-child(4) { transition-delay: 0.2s; }

        .nav-links {
          width: 100%;
          padding: 16px 20px;
          text-align: left;
          justify-content: space-between;
          border-radius: 14px;
          margin-bottom: 10px;
          background: #fff;
          box-shadow: 0 2px 8px rgba(0, 115, 177, 0.08);
          border: 2px solid rgba(0, 115, 177, 0.1);
          font-size: 1rem;
          transform: none;
        }

        .nav-links:hover {
          background: linear-gradient(135deg, rgba(0, 115, 177, 0.08), rgba(107, 190, 68, 0.08));
          border-color: rgba(0, 115, 177, 0.2);
          transform: scale(1.02);
        }

        .nav-links.active {
          background: linear-gradient(135deg, #0073b1, #005a8c);
          color: #fff;
          border-color: #0073b1;
          box-shadow: 0 4px 16px rgba(0, 115, 177, 0.25);
        }

        .nav-links.active .chevron-icon {
          color: #fff;
        }

        /* --- Mobile Dropdown Styles --- */
        .dropdown-menu {
          position: static !important;
          width: 100%;
          box-shadow: none;
          border-radius: 14px;
          background: rgba(0, 115, 177, 0.04);
          padding: 0;
          margin: 0 0 10px 0;
          max-height: 0;
          overflow: hidden;
          opacity: 1 !important;
          visibility: visible !important;
          transform: none !important;
          transition: max-height 0.4s cubic-bezier(0.4, 0, 0.6, 1), padding 0.4s ease;
          border: 2px solid rgba(0, 115, 177, 0.1);
          left: auto;
          top: auto;
        }

        .dropdown-menu::before {
          display: none;
        }

        .dropdown-menu.active {
          max-height: 800px !important;
          padding: 10px;
        }

        .dropdown-link {
          padding: 14px 16px;
          font-size: 0.95rem;
          border-radius: 12px;
          background: #fff;
          margin-bottom: 6px;
          box-shadow: 0 2px 6px rgba(0, 115, 177, 0.06);
          border: 2px solid rgba(0, 115, 177, 0.08);
          transform: none;
        }

        .dropdown-link:last-child {
          margin-bottom: 0;
        }

        .dropdown-link:hover {
          background: linear-gradient(135deg, rgba(0, 115, 177, 0.08), rgba(107, 190, 68, 0.08));
          transform: scale(1.02);
          border-color: rgba(0, 115, 177, 0.15);
        }

        .dropdown-link.active {
          background: linear-gradient(135deg, rgba(0, 115, 177, 0.15), rgba(107, 190, 68, 0.15));
          border-color: #0073b1;
          box-shadow: 0 4px 12px rgba(0, 115, 177, 0.15);
        }
      }

      @media screen and (max-width: 480px) {
        .navbar {
          height: 65px;
        }

        .navbar.scrolled {
          height: 63px;
        }

        .navbar-container {
          padding: 0 16px;
        }

        .logo-img {
          height: 100px;
        }

        .nav-menu {
          top: 65px;
          height: calc(100vh - 65px);
          padding: 16px 12px 32px;
        }

        .nav-links {
          padding: 14px 16px;
          font-size: 0.95rem;
          margin-bottom: 8px;
        }

        .dropdown-link {
          padding: 12px 14px;
          font-size: 0.9rem;
        }
      }

      /* Mobile menu overlay */
      .menu-overlay {
        display: none;
        position: fixed;
        top: 70px;
        left: 0;
        width: 100%;
        height: calc(100vh - 70px);
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        z-index: 998;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
        pointer-events: none;
      }

      @media screen and (max-width: 960px) {
        .menu-overlay {
          display: block;
        }
        
        .menu-overlay.active {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
        }
      }

      @media screen and (max-width: 480px) {
        .menu-overlay {
          top: 65px;
          height: calc(100vh - 65px);
        }
      }
    `;

    const styleEl = document.createElement('style');
    styleEl.id = 'navbar-styles';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);

    return () => {
      const el = document.getElementById('navbar-styles');
      if (el) {
        document.head.removeChild(el);
      }
    };
  }, []);

  return null;
};
// --- End Injected CSS Styles ---

function Navbar() {
  const [click, setClick] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const [dropdown, setDropdown] = React.useState(false);
  const [productCategories, setProductCategories] = React.useState([]);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => {
    setClick(false);
    setDropdown(false);
  };

  React.useEffect(() => {
    const fetchCategories = async () => {
      const products = await productService.getAllProducts();
      const uniqueCategories = Array.from(new Set(products.map(p => p.category).filter(Boolean)));
      setProductCategories(uniqueCategories.map(name => ({ name })));
    };
    fetchCategories();
  }, []);

  const onMouseEnter = () => {
    if (window.innerWidth >= 960) {
      setDropdown(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth >= 960) {
      setDropdown(false);
    }
  };

  const handleProductsClick = (e) => {
    e.preventDefault();
    if (window.innerWidth < 960) {
      setDropdown(!dropdown);
    } else {
      setDropdown(!dropdown);
    }
  };

  const handleDropdownItemClick = () => {
    setDropdown(false);
    closeMobileMenu();
    scrollToTop();
  };

  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close mobile menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (click && !e.target.closest('.nav-menu') && !e.target.closest('.menu-icon')) {
        closeMobileMenu();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [click]);

  // Prevent body scroll when mobile menu is open
  React.useEffect(() => {
    if (click) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [click]);

  return (
    <>
      <NavbarStyles />
      
      {/* Mobile menu overlay */}
      <div className={click ? 'menu-overlay active' : 'menu-overlay'} onClick={closeMobileMenu}></div>
      
      <nav className={scrolled ? 'navbar scrolled' : 'navbar'}>
        <div className="navbar-container">
          {/* Logo */}
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img src="/images/footer.png" alt="Rafferty Logo" className="logo-img" />
          </Link>
          
          {/* Mobile Menu Icon */}
          <div className="menu-icon" onClick={handleClick}>
            {click ? <CloseIcon /> : <HamburgerIcon />}
          </div>
          
          {/* Navigation Menu */}
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            {/* Home */}
            <li className="nav-item">
              <NavLink to="/" className={({ isActive }) => 'nav-links' + (isActive ? ' active' : '')} onClick={closeMobileMenu} end>
                Home
              </NavLink>
            </li>
            
            {/* About Us */}
            <li className="nav-item">
              <NavLink to="/about" className={({ isActive }) => 'nav-links' + (isActive ? ' active' : '')} onClick={closeMobileMenu}>
                About Us
              </NavLink>
            </li>
            
            {/* Products (Dropdown) */}
            <li 
              className="nav-item has-dropdown" 
              onMouseEnter={onMouseEnter} 
              onMouseLeave={onMouseLeave}
            >
              <a
                href='/products'
                className="nav-links"
                onClick={handleProductsClick}
              >
                Products
                <ChevronDownIcon className={`chevron-icon ${dropdown ? 'open' : ''}`} />
              </a>
              
              {/* Dropdown Menu */}
              <ul className={dropdown ? 'dropdown-menu active' : 'dropdown-menu'}>
                {productCategories.map((category) => (
                  <li key={category.name}>
                    <NavLink
                      to={`/products/${category.name}`}
                      className={({ isActive }) => 'dropdown-link' + (isActive ? ' active' : '')}
                      onClick={handleDropdownItemClick}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                        {React.createElement(getCategoryIcon(category.name), { size: 20, color: 'currentColor' })}
                        {category.name}
                      </span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
            {/* Contact */}
            <li className="nav-item">
              <NavLink to="/Processing" className={({ isActive }) => 'nav-links' + (isActive ? ' active' : '')} onClick={closeMobileMenu}>
              Processing
              </NavLink>
            </li>
              {/* Contact */}
              <li className="nav-item">
              <NavLink to="/contact" className={({ isActive }) => 'nav-links' + (isActive ? ' active' : '')} onClick={closeMobileMenu}>
                Contact Us
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;